import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './StarInput.scss';

class StarInput extends React.Component {
  static propTypes = {
    /** custom classname to add to the component. */
    className: PropTypes.string,
    /** function to call when value changed. */
    onChange: PropTypes.func,
    /** value of the input. */
    value: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
  };

  static defaultProps = {
    className: '',
    onChange: () => {},
  };

  state = {
    currentValue: this.props.value || 0,
  };

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setValue(this.props.value);
    }
  }

  setValue = value => {
    this.setState({ currentValue: value || 0 });
  };

  render() {
    const { className, onChange, value } = this.props;
    const { currentValue } = this.state;

    return (
      <div
        className={classnames('common-input', 'common-star-input', className)}
      >
        {[1, 2, 3, 4, 5].map(num => (
          <div
            key={num}
            className="common-star-input__star"
            onClick={() => onChange(num)}
            onMouseEnter={() => this.setValue(num)}
            onMouseLeave={() => this.setValue(value)}
          >
            <i
              className={classnames('fa', {
                'fa-star': num <= currentValue,
                'fa-star-o': num > currentValue,
              })}
            />
          </div>
        ))}
      </div>
    );
  }
}

export default StarInput;



// WEBPACK FOOTER //
// ./src/components/common/star-input/StarInput.js